import { HimuraInject } from 'himura';
import { CommonConfig } from '../../../configs/config.common';
import { AxiosPromise } from '../../../utils/axios.promise';
import * as T_T from 'cryface';

@HimuraInject.NamedService('MapEpicListDelegate')
export class MapEpicListDelegate {
    public currentList = [];

    public config: CommonConfig = new CommonConfig();

    // public async getList(lat: number, lng: number, radius = 1000, sort = {
    //     name: 'listingCreatedTime',
    //     descOrAsc: 0,
    // }) {
    //     const cimsApiHost = this.config.cmisapiHost;
    //     const requestBody = {
    //         houCondition: {
    //             longitude: lng.toString(),
    //             latitude: lat.toString(),
    //             radius: radius,
    //             sortBy: sort.name,
    //             descOrAsc: sort.descOrAsc,
    //         },
    //         ltype: 0,
    //     };
    //     try {
    //         const fetched = await AxiosPromise.postJson(`${cimsApiHost}/mh/queryHouConditionMap`, requestBody);
    //         if (fetched.status === 200) {
    //             this.lessPictures(fetched.data.data.list);
    //             fetched.data.data.list = this.dropBadData(fetched.data.data.list);
    //             return fetched.data;
    //         }
    //     } catch (e) { }
    //     return undefined;
    // }

    public async getListByPage(houCondition: any, page = 1, sort = {
        name: 'listingCreatedTime',
        descOrAsc: 0,
    }) {
        const cimsApiHost = this.config.cmisapiHost;
        houCondition.sortBy = sort.name;
        houCondition.descOrAsc = sort.descOrAsc;
        houCondition.realEstateBoard = 'treb';
        const requestBody = {
            houCondition: houCondition,
            page: page,
            rows: 54,
            userid: 0,
            ltype: 0,
        };
        try {
            const fetched = await AxiosPromise.postJson(`${cimsApiHost}/mh/queryHouCondition`, requestBody);
            if (fetched.status === 200) {
                this.lessPictures(fetched.data.data);
                fetched.data.data = this.dropBadData(fetched.data.data);
                return fetched.data;
            }
        } catch (e) { }
        return undefined;
    }

    public async getSingleListById(identifier: string, radius = 1000) {
        const cimsApiHost = this.config.cmisapiHost;
        try {
            const fetched = await AxiosPromise.get(`${cimsApiHost}/mh/queryHouIdMap?houid=${identifier.trim()}&ltype=0&userid=1`);
            if (fetched.code === 200) {
                return fetched.data;
            }
        } catch (e) { }
        return undefined;
    }

    public lessPictures(list: any) {
        list.map((property: any) => {
            if (T_T.simpleDetect(property.pictures)) {
                if (property.pictures.length > 1) {
                    property.pictures = property.pictures.slice(0, 1);
                }
            }
        });
    }

    public dropBadData(list: any) {
        return list.filter((v: any) => v.price - 200 > 0);
    }
}
